import { AiProcessStatus } from '@/features/AiChat/model/api/chat/types.ts';
import { ChatService, SessionService } from '@/features/AiChat/model/context/types.ts';
import { DEFAULT_ADVANCE_VALUE } from '@/features/AiChat/model/constants';
import { noop } from '@/shared/utils/noop.ts';

const initialSessionService: SessionService = {
  methods: {
    addMessageToHistory: noop,
    removeFile: noop,
    sendMessage: () => Promise.resolve(false),
    sendMessageAction: noop,
    sendMessageChips: noop,
    setActiveSession: noop,
    setAdvanceValue: noop,
    setAiProcessStatus: noop,
    setInputValue: noop,
    setInvoiceItems: noop,
    setIsFileModalOpen: noop,
    setSelectedFiles: noop,
    startPolling: noop,
    stopPolling: noop
  },
  state: {
    activeSession: null,
    advanceValue: DEFAULT_ADVANCE_VALUE,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    aiProcessCurrentStep: '',
    aiProcessStatus: AiProcessStatus.IDLE,
    inputValue: '',
    invoiceItems: [],
    isAdvanceFromInvoice: false,
    isFileModalOpen: false,
    isMessageSending: false,
    messagesEndRef: null,
    selectedFiles: []
  }
};

export const initialValue: ChatService = {
  methods: {
    addSession: noop,
    closeChat: noop,
    closeChatSession: noop,
    openChat: noop,
    openChatSession: noop,
    removeSession: noop,
    setChatSessions: noop
  },
  state: {
    aiAccess: {
      canUseAi: false,
      hasOrganization: false,
      isAiAccessLoading: false,
      isEmailVerified: false,
      tokenData: null
    },
    aiCarouselItems: [],
    chatIsOpen: false,
    chatSessions: [],
    sessionService: initialSessionService
  }
};